// Translations for CZ / EN / DE
export const translations = {
  cz: {
    nav: {
      about: "O půjčovně",
      fleet: "Plavidla a ceník",
      pricing: "Ceník",
      reviews: "Recenze",
      contact: "Kontakt",
      callNow: "Zavolat",
      directions: "Navigovat",
      orFindUs: "nebo nás najděte na mapě",
      noSwim: "Zákaz koupání ze člunu",
      swimBoat: "Koupání ze člunu",
      swimPedal: "Koupání ze šlapadla",
    },
    hero: {
      eyebrow: "Pasohlávky · ATC Merkur · Nové Mlýny",
      title1: "Půjčovna motorových",
      title2: "člunů a šlapadel",
      subtitle: "",
      ctaCall: "Rezervovat",
      ctaPricing: "Zobrazit ceník",
      stat1: "5 typů plavidel",
      stat2: "Bez řidičského průkazu",
      stat3: "Krátká instruktáž",
    },
    about: {
      eyebrow: "O půjčovně",
      title: "Pálava jinak — na hladině jezera, z vlastního člunu.",
      p1: "Půjčujeme motorové čluny s benzínovým motorem o výkonu 5 Hp, elektrické čluny se stříškou a motorem 3 Hp, lehátková šlapadla a šlapadla se skluzavkou.",
      p2: "Půjčovna se nachází v největším a nejnavštěvovanějším autokempu ATC Merkur na velkém jezeře horní nádrže Nových Mlýnů pod Pálavskými vrchy. K plavbě máte celou vodní plochu velkého jezera s krásným výhledem na Pálavu.",
      p3: "Po krátké instruktáži můžete vyplout a stát se kapitánem plavidla i vlastního času. Těšíme se na Vaši návštěvu.",
      bullet1: "Bez řidičského oprávnění",
      bullet2: "Pro celou rodinu",
      bullet3: "Krásný výhled na Pálavu",
      bullet4: "V ATC Merkur",
    },
    fleet: {
      eyebrow: "Naše plavidla",
      title: "Vyberte si plavidlo.",
      subtitle:
        "Pět typů plavidel pro každého — od pohodového šlapání s rodinou až po rychlou jízdu motorovým člunem.",
      perHour: "/ hodina",
      capacity: "osoby",
      capacity5: "osob",
      items: {
        motor: {
          name: "Motorový člun",
          desc: "Benzínový motor 5 Hp. Pro ty, kdo chtějí svobodu a rychlost na vodě.",
          tag: "Nejoblíbenější",
        },
        electricRoof: {
          name: "Elektrický člun se stříškou",
          desc: "Tichá jízda ve stínu stříšky. Ideální pro horké letní dny.",
          tag: "Stín & klid",
        },
        electric: {
          name: "Elektrický člun",
          desc: "Tichý elektromotor 3 Hp. Šetrný k přírodě, zábava pro celou rodinu.",
          tag: "Volný výhled",
        },
        pedal: {
          name: "Lehátkové šlapadlo",
          desc: "Klasické šlapadlo s pohodlnými lehátky pro relaxaci na hladině.",
          tag: "Pohoda",
        },
        pedalSlide: {
          name: "Šlapadlo se skluzavkou",
          desc: "Zábava pro děti i dospělé — skluzavka přímo do jezera.",
          tag: "Pro děti",
        },
      },
    },
    faq: {
      eyebrow: "Časté dotazy",
      title: "Vše, co potřebujete vědět před vyplutím.",
      contactNote: "Máte jiný dotaz? Zavolejte nám na",
      q1: "Potřebuji řidičský průkaz na člun?",
      a1: "Ne. Žádný z našich člunů ani šlapadel nevyžaduje speciální oprávnění. Před vyplutím vás krátce zaškolíme.",
      q2: "Jak je to se vstupem do kempu?",
      a2: "Vstup do kempu ATC Merkur je zvlášť a není součástí ceny půjčení plavidel. Aktuální ceník vstupného najdete na stránkách kempu.",
      q3: "Je nutná rezervace předem?",
      a3: "V hlavní sezóně rezervaci doporučujeme. Stačí zavolat na 724 909 002 — domluvíme termín.",
      q4: "Kam všude můžeme s plavidlem plout?",
      a4: "Po středu celé horní nádrže. Prosíme nekotvit a nepřibližovat se ke břehům — kvůli nízké hladině, kamenům a rybářům.",
      q5: "Kde se půjčovna nachází?",
      a5: "V autokempu ATC Merkur, Pasohlávky 61, 691 22 — na horní nádrži Nových Mlýnů pod Pálavou.",
      q6: "Co když nestihneme přijet podle plánu?",
      a6: "Volejte nám prosím co nejdříve na 724 909 002.",
      q7: "Jaké jsou platební možnosti?",
      a7: "Přijímáme pouze hotovost, případně QR kód.",
    },
    reviews: {
      eyebrow: "Recenze",
      title: "Co o nás říkají návštěvníci.",
      subtitle: "Hodnocení z Google.",
      readMore: "Číst více recenzí na Google",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Přijeďte k nám na vodu.",
      hoursTitle: "Otevírací doba",
      lastRentalNote: "Poslední půjčení je hodinu před zavírací dobou.",
      hours: {
        spring: { range: "1. dubna – 30. května", value: "dle domluvy po telefonu" },
        summer: { range: "1. června – 31. srpna", value: "každý den 9:00 – 21:00" },
        autumn: { range: "1. – 30. září", value: "každý den 10:00 – 18:00" },
      },
      phoneLabel: "Rezervace / telefon půjčovny",
      addressLabel: "Adresa",
      addressValue: "Pasohlávky 61, 691 22 Pasohlávky\nATC Merkur",
      callCta: "Zavolat nyní",
      directionsCta: "Navigovat",
    },
    footer: {
      tagline: "Půjčovna motorových člunů a šlapadel.",
      rights: "Všechna práva vyhrazena.",
      backTop: "Nahoru",
      downloadTitle: "Stáhnout kompletní web",
      downloadDesc: "Statická verze webu jako ZIP — nahrajte na jakýkoli webhosting a stránky poběží.",
      downloadCta: "Stáhnout ZIP",
    },
  },
  en: {
    nav: {
      about: "About",
      fleet: "Boats & pricing",
      pricing: "Pricing",
      reviews: "Reviews",
      contact: "Contact",
      callNow: "Call us",
      directions: "Get directions",
      orFindUs: "or find us on the map",
      noSwim: "No swimming from this boat",
      swimBoat: "Swimming from boat",
      swimPedal: "Swimming from pedal boat",
    },
    hero: {
      eyebrow: "Pasohlávky · ATC Merkur · Nové Mlýny",
      title1: "Motor boat and",
      title2: "pedal boat rental",
      subtitle: "",
      ctaCall: "Reserve",
      ctaPricing: "See pricing",
      stat1: "5 types of boats",
      stat2: "No license needed",
      stat3: "Short briefing",
    },
    about: {
      eyebrow: "About us",
      title: "Pálava the way few experience it — on the lake, from your own boat.",
      p1: "We rent motorboats with a 5 Hp petrol engine, electric boats with a roof and a 3 Hp motor, lounger pedal boats and pedal boats with a slide.",
      p2: "Our rental is located in the largest and most visited campground ATC Merkur on the big lake of the upper Nové Mlýny reservoir below the Pálava hills. The whole water surface of the big lake with a beautiful view of Pálava is yours to explore.",
      p3: "After a short briefing you can set sail and become the captain of your boat — and your own time. We look forward to your visit.",
      bullet1: "No license required",
      bullet2: "For the whole family",
      bullet3: "Stunning Pálava views",
      bullet4: "At ATC Merkur",
    },
    fleet: {
      eyebrow: "Our fleet",
      title: "Pick your boat.",
      subtitle:
        "Five types of boats for everyone — from a relaxed family pedal to a fast motorboat run.",
      perHour: "/ hour",
      capacity: "people",
      capacity5: "people",
      items: {
        motor: {
          name: "Motor boat",
          desc: "Petrol engine 5 Hp. For those who want freedom and speed on the water.",
          tag: "Most popular",
        },
        electricRoof: {
          name: "Electric boat with roof",
          desc: "Silent ride in the shade. Perfect for hot summer days.",
          tag: "Shade & calm",
        },
        electric: {
          name: "Electric boat",
          desc: "Silent 3 Hp electric motor. Nature-friendly fun for the whole family.",
          tag: "Open view",
        },
        pedal: {
          name: "Lounger pedal boat",
          desc: "Classic pedal boat with comfy loungers to relax on the surface.",
          tag: "Chill",
        },
        pedalSlide: {
          name: "Pedal boat with slide",
          desc: "Fun for kids and adults — slide straight into the lake.",
          tag: "For kids",
        },
      },
    },
    faq: {
      eyebrow: "FAQ",
      title: "Everything you need before setting sail.",
      contactNote: "Got a different question? Call us at",
      q1: "Do I need a boating license?",
      a1: "No. None of our boats or pedal boats require any license. We give you a short briefing before you set off.",
      q2: "What about the campground entrance fee?",
      a2: "Access to the ATC Merkur campground is separate and not included in the boat rental price. You can find the current entry fee on the campground's website.",
      q3: "Should I book in advance?",
      a3: "In high season we recommend booking. Just call +420 724 909 002 — we'll arrange a time.",
      q4: "Where can we sail with the boat?",
      a4: "Along the middle of the upper reservoir. Please do not anchor and avoid getting close to the shoreline — the water is shallow, there are rocks and anglers along the shore.",
      q5: "Where is the rental located?",
      a5: "At ATC Merkur campground, Pasohlávky 61, 691 22 — on the upper Nové Mlýny reservoir below Pálava.",
      q6: "What if we're running late?",
      a6: "Please call us asap at +420 724 909 002.",
      q7: "What about payments?",
      a7: "We accept cash only, or QR code payment.",
    },
    reviews: {
      eyebrow: "Reviews",
      title: "What our visitors say.",
      subtitle: "Ratings from Google.",
      readMore: "Read more reviews on Google",
    },
    contact: {
      eyebrow: "Contact",
      title: "Come and join us on the water.",
      hoursTitle: "Opening hours",
      lastRentalNote: "Last rental is one hour before closing time.",
      hours: {
        spring: { range: "April 1 – May 30", value: "by phone appointment" },
        summer: { range: "June 1 – August 31", value: "every day 9:00 – 21:00" },
        autumn: { range: "September 1 – 30", value: "every day 10:00 – 18:00" },
      },
      phoneLabel: "Reservations / phone",
      addressLabel: "Address",
      addressValue: "Pasohlávky 61, 691 22 Pasohlávky\nATC Merkur",
      callCta: "Call now",
      directionsCta: "Get directions",
    },
    footer: {
      tagline: "Motor boat and pedal boat rental.",
      rights: "All rights reserved.",
      backTop: "Back to top",
      downloadTitle: "Download the whole website",
      downloadDesc: "Static build as a ZIP — upload it to any web hosting and the site will run.",
      downloadCta: "Download ZIP",
    },
  },
  de: {
    nav: {
      about: "Über uns",
      fleet: "Boote & Preise",
      pricing: "Preise",
      reviews: "Bewertungen",
      contact: "Kontakt",
      callNow: "Anrufen",
      directions: "Route",
      orFindUs: "oder finden Sie uns auf der Karte",
      noSwim: "Schwimmen vom Boot verboten",
      swimBoat: "Schwimmen vom Boot",
      swimPedal: "Schwimmen vom Tretboot",
    },
    hero: {
      eyebrow: "Pasohlávky · ATC Merkur · Nové Mlýny",
      title1: "Motorboot- und",
      title2: "Tretbootverleih",
      subtitle: "",
      ctaCall: "Reservieren",
      ctaPricing: "Preise ansehen",
      stat1: "5 Bootstypen",
      stat2: "Kein Führerschein",
      stat3: "Kurze Einweisung",
    },
    about: {
      eyebrow: "Über uns",
      title: "Pálava einmal anders — auf dem See, vom eigenen Boot aus.",
      p1: "Wir vermieten Motorboote mit 5 PS Benzinmotor, Elektroboote mit Dach und 3 PS Motor, Liegen-Tretboote sowie Tretboote mit Rutsche.",
      p2: "Unser Verleih liegt im größten und meistbesuchten Campingplatz ATC Merkur am großen See des Oberen Stausees Nové Mlýny unter den Pálava-Hügeln. Die gesamte Wasserfläche des großen Sees mit herrlichem Blick auf Pálava steht Ihnen offen.",
      p3: "Nach einer kurzen Einweisung können Sie ablegen und Kapitän Ihres Bootes — und Ihrer Zeit — werden. Wir freuen uns auf Ihren Besuch.",
      bullet1: "Kein Führerschein nötig",
      bullet2: "Für die ganze Familie",
      bullet3: "Wunderschöner Pálava-Blick",
      bullet4: "Im ATC Merkur",
    },
    fleet: {
      eyebrow: "Unsere Flotte",
      title: "Wählen Sie Ihr Boot.",
      subtitle:
        "Fünf Bootstypen für jeden — vom entspannten Familientreten bis zur schnellen Motorbootfahrt.",
      perHour: "/ Stunde",
      capacity: "Personen",
      capacity5: "Personen",
      items: {
        motor: {
          name: "Motorboot",
          desc: "Benzinmotor 5 PS. Für alle, die Freiheit und Geschwindigkeit auf dem Wasser wollen.",
          tag: "Am beliebtesten",
        },
        electricRoof: {
          name: "Elektroboot mit Dach",
          desc: "Leise Fahrt im Schatten. Ideal für heiße Sommertage.",
          tag: "Schatten & Ruhe",
        },
        electric: {
          name: "Elektroboot",
          desc: "Leiser 3 PS Elektromotor. Naturschonender Spaß für die ganze Familie.",
          tag: "Freie Sicht",
        },
        pedal: {
          name: "Liegen-Tretboot",
          desc: "Klassisches Tretboot mit bequemen Liegen zum Entspannen auf dem Wasser.",
          tag: "Entspannung",
        },
        pedalSlide: {
          name: "Tretboot mit Rutsche",
          desc: "Spaß für Kinder und Erwachsene — Rutsche direkt in den See.",
          tag: "Für Kinder",
        },
      },
    },
    faq: {
      eyebrow: "FAQ",
      title: "Alles, was Sie vor dem Auslaufen wissen müssen.",
      contactNote: "Andere Frage? Rufen Sie uns an unter",
      q1: "Brauche ich einen Bootsführerschein?",
      a1: "Nein. Keines unserer Boote oder Tretboote erfordert eine Genehmigung. Wir geben Ihnen eine kurze Einweisung.",
      q2: "Wie sieht es mit dem Campingplatz-Eintritt aus?",
      a2: "Der Zugang zum Campingplatz ATC Merkur ist separat und nicht im Bootspreis enthalten. Die aktuelle Eintrittsgebühr finden Sie auf der Website des Campingplatzes.",
      q3: "Soll ich vorab reservieren?",
      a3: "In der Hauptsaison empfehlen wir eine Reservierung. Rufen Sie einfach +420 724 909 002 an.",
      q4: "Wohin dürfen wir mit dem Boot fahren?",
      a4: "Entlang der Mitte des Oberen Stausees. Bitte nicht ankern und sich nicht den Ufern nähern — wegen niedriger Wasserstände, Steinen und Anglern am Ufer.",
      q5: "Wo befindet sich der Verleih?",
      a5: "Im Campingplatz ATC Merkur, Pasohlávky 61, 691 22 — am Oberen Stausee Nové Mlýny unter Pálava.",
      q6: "Was, wenn wir uns verspäten?",
      a6: "Bitte rufen Sie uns sofort unter +420 724 909 002 an.",
      q7: "Wie kann ich bezahlen?",
      a7: "Wir akzeptieren nur Barzahlung, alternativ Zahlung per QR-Code.",
    },
    reviews: {
      eyebrow: "Bewertungen",
      title: "Was unsere Besucher sagen.",
      subtitle: "Bewertungen von Google.",
      readMore: "Weitere Bewertungen auf Google lesen",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Kommen Sie zu uns aufs Wasser.",
      hoursTitle: "Öffnungszeiten",
      lastRentalNote: "Die letzte Vermietung erfolgt eine Stunde vor Schließzeit.",
      hours: {
        spring: { range: "1. April – 30. Mai", value: "nach telefonischer Absprache" },
        summer: { range: "1. Juni – 31. August", value: "täglich 9:00 – 21:00" },
        autumn: { range: "1. – 30. September", value: "täglich 10:00 – 18:00" },
      },
      phoneLabel: "Reservierung / Telefon",
      addressLabel: "Adresse",
      addressValue: "Pasohlávky 61, 691 22 Pasohlávky\nATC Merkur",
      callCta: "Jetzt anrufen",
      directionsCta: "Route",
    },
    footer: {
      tagline: "Motorboot- und Tretbootverleih.",
      rights: "Alle Rechte vorbehalten.",
      backTop: "Nach oben",
      downloadTitle: "Ganze Website herunterladen",
      downloadDesc: "Statischer Build als ZIP — laden Sie es auf ein beliebiges Webhosting hoch und die Seite läuft.",
      downloadCta: "ZIP herunterladen",
    },
  },
};

export const LANGS = [
  { code: "cz", label: "CZ" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
];
